import { ReactElement, useContext } from "react";
import { ApplicationLocationContext } from "../../utils/ApplicationState";
import { AppBar, Box, List, ListItemButton, ListItemIcon, ListItemText, Toolbar } from "@mui/material";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import WelcomeName from "./WelcomeName";
import { NavbarRoutes } from "../../NavBarRoutes";
import logo from "../../img/SpiritNightLogo.png";

export const NavigationBar = ({ menuItems }: { menuItems: NavbarRoutes[] }): ReactElement => {
  const { state } = useContext(ApplicationLocationContext);

  return (
    <AppBar
      sx={{
        backgroundColor: "#000000",
        width: "100%",
        boxShadow: "0px 10px 20px 0px #0000000A",
        position: "relative",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 28px",
        }}
      >
        <a href="/" style={{ display: "flex", alignItems: "center" }}>
          <img
            src={logo}
            alt="Torchy's Logo"
            style={{
              width: "133px",
              height: "36px",
              opacity: 1,
            }}
          />
        </a>

        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <List
            component={"nav"}
            sx={{
              display: "flex",
              gap: "10px",
              width: "233px",
              height: "26px",
              alignItems: "center",
              "& .MuiListItemButton-root": {
                width: "100px",
                height: "26px",
                color: "white",
                justifyContent: "center",
                padding: 0,
                borderRadius: "8px",
                "&.Mui-selected": {
                  backgroundColor: "rgb(166, 25, 46)",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "rgb(166, 25, 46)",
                  },
                },
                "&:hover": {
                  backgroundColor: "rgba(166, 25, 46, 0.2)",
                },
              },
            }}
          >
            {menuItems
              .filter((item) => item.name !== "Help Page")
              .map((item, i) => (
                <ListItemButton key={item.name} component="a" href={"/" + item.routerPath} selected={state.path.includes(item.name)}>
                  <ListItemIcon sx={{ minWidth: "unset", color: "inherit" }}>{item.icon}</ListItemIcon>
                  <ListItemText disableTypography primary={item.name} sx={{ color: "inherit", fontSize: "14px", textAlign: "center" }} />
                </ListItemButton>
              ))}
          </List>

          {/* Auth buttons */}
          <AuthenticatedTemplate>
            <WelcomeName />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <SignInButton />
          </UnauthenticatedTemplate>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
